export default __webpack_public_path__ + "static/media/englishIcon.b803b54c.svg";